import React, { useState, useEffect } from "react";
import useDarkMode from '../../hooks/useDarkMode';
import useThemeColor from "../../hooks/useThemeColor";
import { Link, useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import FormInput from "../../components/CustomComponents/Input/formInput";
import ToggleSwitch from "../../components/CustomComponents/Switchery/switchery";
import Preloader from "../../components/CustomComponents/preLoad/preLoader";
import axiosInstance from "../../config/axiosApi/axiosApi";
import APIs from "../../Constants/apis";
import { useSelector } from "react-redux";
import showErrorToast, {
  showSuccessToast,
} from "../../components/CustomComponents/toast/toast";

function UpdateRole() {
  const backOfficePermissionKeys = [
    "canViewDashboard",
    "canAccessOrders",
    "canAccessReports",
    "canAccessStaff",
    "canAccessCustomers",
    "canAccessItemCatalog",
    "canAccessPurchase",
    "canAccessDiningManagement",
    "canAccessSettings",
    "canAccessAdministration",
  ];
  const { roleId } = useParams();
  const CompID = useSelector((state) => state.auth.user)?.userData?.compID;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [isPermanentRole, setIsPermanentRole] = useState(false);
  const isReadOnly = isPermanentRole;

  // Get app settings from Redux
  const appSettings = useSelector((state) => state.appSettings);
  const { appTheme } = appSettings;

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();

  // Get theme color from centralized hook
  const themeColor = useThemeColor();




  const [formData, setFormData] = useState({
    ComRolePermission_ID: 0,
    R_Title: "",
    IsAdmin: false,
    ISBackOffice: false,
    ISStaffAPP: false,
    AllowAdminAccessOntheTill: false,
    AllowTillSettings: false,
    AllowPettyCashes: false,
    AllowFloatAdjustments: false,
    AllowBackOfficeAccessFromTill: false,
    AllowAccessToCustomerList: false,
    CanAccessZreport: false,
    AllowTillClosingBlindEndofDay: false,
    AllowAllVoidLines: false,
    AllowTablePlanning: false,
    AllowMultipleTimeReceiptPrint: false,
    ShowPrintButtons: true,
    AllowBasketDiscounts: false,
    BasketDiscountLimit: null,
    BasketDiscountLimitPercentage: null,
    AllowRefunds: false,
    RefundLimit: null,
    canViewDashboard: false,
    canAccessOrders: false,
    canAccessReports: false,
    isAllowedSaleReport: false,
    isAllowedGeneralReport: false,
    canAccessStaff: false,
    canAccessCustomers: false,
    canAccessItemCatalog: false,
    canAccessPurchase: false,
    canAccessDiningManagement: false,
    canAccessSettings: false,
    canAccessAdministration: false,
    IsPermanentRole: false,
    CompID: CompID || 0,
  });

  useEffect(() => {
    const fetchRoleData = async () => {
      setFetching(true);
      try {
        const response = await axiosInstance.get(APIs.GET_ROLE_BY_ID, {
          params: { CompID, id: roleId },
        });

        if (response.data.status && response.data.data) {
          const roleData = response.data.data;

          if (roleData.isPermanentRole === true || roleData.isPermanentRole === 1) {
            setIsPermanentRole(true);
          }

          setFormData({
            ComRolePermission_ID: roleData.comRolePermission_ID,
            R_Title: roleData.r_Title,
            IsAdmin: roleData.isAdmin,
            ISBackOffice: roleData.isBackOffice,
            ISStaffAPP: roleData.isStaffAPP ?? roleData.iSStaffAPP ?? roleData.ISStaffAPP ?? false,
            AllowAdminAccessOntheTill: roleData.allowAdminAccessOntheTill,
            AllowTillSettings: roleData.allowTillSettings,
            AllowPettyCashes: roleData.allowPettyCashes,
            AllowFloatAdjustments: roleData.allowFloatAdjustments,
            AllowBackOfficeAccessFromTill: roleData.allowBackOfficeAccessFromTill,
            AllowAccessToCustomerList: roleData.allowAccessToCustomerList,
            CanAccessZreport: roleData.canAccessZreport,
            AllowTillClosingBlindEndofDay: roleData.allowTillClosingBlindEndofDay,
            AllowAllVoidLines: roleData.allowAllVoidLines,
            AllowTablePlanning: roleData.allowTablePlanning,
            AllowMultipleTimeReceiptPrint: roleData.allowMultipleTimeReceiptPrint,
            ShowPrintButtons: roleData.showPrintButtons ?? true,
            AllowBasketDiscounts: roleData.allowBasketDiscounts,
            BasketDiscountLimit: roleData.basketDiscountLimit ?? null,
            BasketDiscountLimitPercentage: roleData.basketDiscountLimitPercentage ?? null,
            AllowRefunds: roleData.allowRefunds,
            RefundLimit: roleData.refundLimit ?? null,
            canViewDashboard: roleData.canViewDashboard ?? false,
            canAccessOrders: roleData.canAccessOrders ?? false,
            canAccessReports: roleData.canAccessReports ?? false,
            isAllowedSaleReport: roleData.isAllowedSaleReport ?? false,
            isAllowedGeneralReport: roleData.isAllowedGeneralReport ?? false,
            canAccessStaff: roleData.canAccessStaff ?? false,
            canAccessCustomers: roleData.canAccessCustomers ?? false,
            canAccessItemCatalog: roleData.canAccessItemCatalog ?? false,
            canAccessPurchase: roleData.canAccessPurchase ?? false,
            canAccessDiningManagement: roleData.canAccessDiningManagement ?? false,
            canAccessSettings: roleData.canAccessSettings ?? false,
            canAccessAdministration: roleData.canAccessAdministration ?? false,
            IsPermanentRole: roleData.isPermanentRole ?? false,
            CompID: CompID || roleData.compID,
          });
        } else {
          showErrorToast("Role not found");
          navigate("/role/manageStaffRole");
        }
      } catch (error) {

        showErrorToast("Failed to fetch role data");
        navigate("/role/manageStaffRole");
      } finally {
        setFetching(false);
      }
    };


    if (roleId && CompID) {
      fetchRoleData();
    }
  }, [roleId, CompID, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value === "" ? null : value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleToggleChange = (checked, name) => {
    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: checked,
      };

      if (name === "ISBackOffice" && !checked) {
        backOfficePermissionKeys.forEach((key) => {
          updated[key] = false;
        });
      }

      return updated;
    });
  };

  const setAllBackOfficePermissions = (value) => {
    setFormData((prev) => {
      const updated = { ...prev };
      backOfficePermissionKeys.forEach((key) => {
        updated[key] = value;
      });
      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.IsPermanentRole) {
      showErrorToast("Cannot update permanent role.");
      return;
    }

    if (!formData.R_Title.trim()) {
      showErrorToast("Role title is required");
      return;
    }

    setLoading(true);

    try {
      const rolePayload = {
        ComRolePermission_ID: parseInt(roleId),
        CompID,
        R_Title: formData.R_Title,
        IsAdmin: formData.IsAdmin,
        ISBackOffice: formData.ISBackOffice,
        ISStaffAPP: formData.ISStaffAPP,
        AllowAdminAccessOntheTill: formData.AllowAdminAccessOntheTill,
        AllowTillSettings: formData.AllowTillSettings,
        AllowPettyCashes: formData.AllowPettyCashes,
        AllowFloatAdjustments: formData.AllowFloatAdjustments,
        AllowBackOfficeAccessFromTill: formData.AllowBackOfficeAccessFromTill,
        AllowAccessToCustomerList: formData.AllowAccessToCustomerList,
        CanAccessZreport: formData.CanAccessZreport,
        AllowTillClosingBlindEndofDay: formData.AllowTillClosingBlindEndofDay,
        AllowAllVoidLines: formData.AllowAllVoidLines,
        AllowTablePlanning: formData.AllowTablePlanning,
        AllowMultipleTimeReceiptPrint: formData.AllowMultipleTimeReceiptPrint,
        ShowPrintButtons: formData.ShowPrintButtons,
        AllowBasketDiscounts: formData.AllowBasketDiscounts,
        BasketDiscountLimit: formData.BasketDiscountLimit ? parseFloat(formData.BasketDiscountLimit) : null,
        BasketDiscountLimitPercentage: formData.BasketDiscountLimitPercentage ? parseFloat(formData.BasketDiscountLimitPercentage) : null,
        AllowRefunds: formData.AllowRefunds,
        RefundLimit: formData.RefundLimit ? parseFloat(formData.RefundLimit) : null,
        canViewDashboard: formData.canViewDashboard,
        canAccessOrders: formData.canAccessOrders,
        canAccessReports: formData.canAccessReports,
        isAllowedSaleReport: formData.isAllowedSaleReport,
        isAllowedGeneralReport: formData.isAllowedGeneralReport,
        canAccessStaff: formData.canAccessStaff,
        canAccessCustomers: formData.canAccessCustomers,
        canAccessItemCatalog: formData.canAccessItemCatalog,
        canAccessPurchase: formData.canAccessPurchase,
        canAccessDiningManagement: formData.canAccessDiningManagement,
        canAccessSettings: formData.canAccessSettings,
        canAccessAdministration: formData.canAccessAdministration,
        IsPermanentRole: formData.IsPermanentRole,

      };

      const response = await axiosInstance.put(
        APIs.UPDATE_ROLE,
        rolePayload
      );
      if (!response.data.status) {
        showErrorToast(response.data.message || "Failed to update role");
        return;
      }

      showSuccessToast("Role updated successfully");
      navigate("/role/manageStaffRole");
    } catch (error) {

      showErrorToast(
        error.response?.data?.message ||
        "An error occurred while updating the role"
      );
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return <Preloader />;
  }

  return (
    <div>
      {(loading) && <Preloader />}
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Home</a>
            </li>
            <li className="breadcrumb-item">
              <Link to="/role/manageStaffRole">Manage Staff Roles</Link>
            </li>
            <li className="breadcrumb-item active">Update Staff Role</li>
          </ol>
          <h1 className="page-header mb-0">Update Staff Role</h1>
        </div>
        <div className="ms-auto">
          <button
            onClick={handleSubmit}
            className="btn px-4"
            type="button"
            disabled={loading || fetching || isReadOnly}
            style={{
              backgroundColor: themeColor,
              background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
              border: 'none',
              color: 'white',
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: `0 2px 8px ${themeColor}40`,
              cursor: (loading || fetching) ? 'not-allowed' : 'pointer',
              opacity: (loading || fetching) ? 0.7 : 1
            }}
            onMouseEnter={(e) => {
              if (!loading && !fetching) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = `0 4px 12px ${themeColor}60`;
              }
            }}
            onMouseLeave={(e) => {
              if (!loading && !fetching) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = `0 2px 8px ${themeColor}40`;
              }
            }}
          >
            {isReadOnly ? "View Only" : (loading ? "Submitting..." : "Update")}
            {/* <i className="fa fa-save fa-lg me-2 ms-n2 text-white"></i> */}
          </button>
        </div>
      </div>
      {isReadOnly && (
        <div className="alert alert-info" role="alert">
          This is a permanent role. You can view permissions, but updates are disabled.
        </div>
      )}
      <div className="row g-4">
        {/* Title Card */}
        <div className="col-12">
          <div
            className="p-4"
            style={{
              backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
              border: isDarkMode ? "1px solid #404040" : "1px solid #dee2e6",
              borderRadius: "12px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
              opacity: isReadOnly ? 0.9 : 1,
              pointerEvents: isReadOnly ? "none" : "auto",
            }}
          >
            <h6
              style={{
                color: isDarkMode ? "#ffffff" : "#495057",
                fontSize: "1.1rem",
                fontWeight: "600",
                marginBottom: "1.5rem",
                paddingBottom: "0.5rem",
                borderBottom: `2px solid ${themeColor}`,
              }}
            >
              <i className="fa fa-user-circle me-2" style={{ color: themeColor }}></i>
              Role Information
            </h6>
            <div className="row g-3">
              <div className="col-12">
                <FormInput
                  label="Role Title *"
                  placeHolder="Enter Role Title"
                  type="text"
                  value={formData.R_Title}
                  onchange={handleInputChange}
                  name="R_Title"
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Admin Access Card */}
        <div className="col-12">
          <div
            className="p-4"
            style={{
              backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
              border: isDarkMode ? "1px solid #404040" : "1px solid #dee2e6",
              borderRadius: "12px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
            }}
          >
            <h6
              style={{
                color: isDarkMode ? "#ffffff" : "#495057",
                fontSize: "1.1rem",
                fontWeight: "600",
                marginBottom: "1.5rem",
                paddingBottom: "0.5rem",
                borderBottom: `2px solid ${themeColor}`,
              }}
            >
              <i className="fa fa-lock me-2" style={{ color: themeColor }}></i>
              Permissions
            </h6>
            <div className="row g-3">
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.IsAdmin}
                  onToggle={(checked) => handleToggleChange(checked, "IsAdmin")}
                  label="Administrator Role"
                  name="IsAdmin"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.ISBackOffice}
                  onToggle={(checked) => handleToggleChange(checked, "ISBackOffice")}
                  label="Back Office Access"
                  name="ISBackOffice"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.ISStaffAPP}
                  onToggle={(checked) => handleToggleChange(checked, "ISStaffAPP")}
                  label="Staff App Access"
                  name="ISStaffAPP"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowAdminAccessOntheTill}
                  onToggle={(checked) => handleToggleChange(checked, "AllowAdminAccessOntheTill")}
                  label="Till Admin Access"
                  name="AllowAdminAccessOntheTill"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowTillSettings}
                  onToggle={(checked) => handleToggleChange(checked, "AllowTillSettings")}
                  label="Modify Till Settings"
                  name="AllowTillSettings"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowPettyCashes}
                  onToggle={(checked) => handleToggleChange(checked, "AllowPettyCashes")}
                  label="Manage Petty Cash"
                  name="AllowPettyCashes"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowFloatAdjustments}
                  onToggle={(checked) => handleToggleChange(checked, "AllowFloatAdjustments")}
                  label="Adjust Cash Float"
                  name="AllowFloatAdjustments"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowBackOfficeAccessFromTill}
                  onToggle={(checked) => handleToggleChange(checked, "AllowBackOfficeAccessFromTill")}
                  label="Access Back Office From Till"
                  name="AllowBackOfficeAccessFromTill"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowAccessToCustomerList}
                  onToggle={(checked) => handleToggleChange(checked, "AllowAccessToCustomerList")}
                  label="View Customer List"
                  name="AllowAccessToCustomerList"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.CanAccessZreport}
                  onToggle={(checked) => handleToggleChange(checked, "CanAccessZreport")}
                  label="Access Z Report"
                  name="CanAccessZreport"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12" style={{ display: "none" }}>
                <ToggleSwitch
                  isChecked={formData.AllowTillClosingBlindEndofDay}
                  onToggle={(checked) => handleToggleChange(checked, "AllowTillClosingBlindEndofDay")}
                  label="Blind Till Closing & End of Day"
                  name="AllowTillClosingBlindEndofDay"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        </div>

        {formData.ISBackOffice && (
          <div className="col-12">
            <div
              className="p-4"
              style={{
                backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                border: isDarkMode ? "1px solid #404040" : "1px solid #dee2e6",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
              }}
            >
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <h6
                  style={{
                    color: isDarkMode ? "#ffffff" : "#495057",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    marginBottom: 0,
                  }}
                >
                  <i className="fa fa-th-large me-2" style={{ color: themeColor }}></i>
                  Back Office Section Access
                </h6>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-success"
                    onClick={() => setAllBackOfficePermissions(true)}
                    disabled={isReadOnly}
                  >
                    Select All
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setAllBackOfficePermissions(false)}
                    disabled={isReadOnly}
                  >
                    Deselect All
                  </button>
                </div>
              </div>
              <div
                style={{
                  marginTop: "0.75rem",
                  marginBottom: "1.5rem",
                  borderBottom: `2px solid ${themeColor}`,
                }}
              />
              <div className="row g-3">
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canViewDashboard} onToggle={(checked) => handleToggleChange(checked, "canViewDashboard")} label="View Dashboard" name="canViewDashboard" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessOrders} onToggle={(checked) => handleToggleChange(checked, "canAccessOrders")} label="Access Orders" name="canAccessOrders" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessReports} onToggle={(checked) => handleToggleChange(checked, "canAccessReports")} label="Access Reports" name="canAccessReports" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessStaff} onToggle={(checked) => handleToggleChange(checked, "canAccessStaff")} label="Access Staff" name="canAccessStaff" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessCustomers} onToggle={(checked) => handleToggleChange(checked, "canAccessCustomers")} label="Access Customers" name="canAccessCustomers" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessItemCatalog} onToggle={(checked) => handleToggleChange(checked, "canAccessItemCatalog")} label="Access Item Catalog" name="canAccessItemCatalog" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessPurchase} onToggle={(checked) => handleToggleChange(checked, "canAccessPurchase")} label="Access Inventory Management" name="canAccessPurchase" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessDiningManagement} onToggle={(checked) => handleToggleChange(checked, "canAccessDiningManagement")} label="Access Dining Management" name="canAccessDiningManagement" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessSettings} onToggle={(checked) => handleToggleChange(checked, "canAccessSettings")} label="Access Settings" name="canAccessSettings" themeColor={themeColor} />
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                  <ToggleSwitch isChecked={formData.canAccessAdministration} onToggle={(checked) => handleToggleChange(checked, "canAccessAdministration")} label="Access Administration" name="canAccessAdministration" themeColor={themeColor} />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Transaction Options Card */}
        <div className="col-12">
          <div
            className="p-4"
            style={{
              backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
              border: isDarkMode ? "1px solid #404040" : "1px solid #dee2e6",
              borderRadius: "12px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
            }}
          >

            <div className="row g-3">
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowAllVoidLines}
                  onToggle={(checked) => handleToggleChange(checked, "AllowAllVoidLines")}
                  label="Void Orders & Lines"
                  name="AllowAllVoidLines"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowTablePlanning}
                  onToggle={(checked) => handleToggleChange(checked, "AllowTablePlanning")}
                  label="Manage Table Planning"
                  name="AllowTablePlanning"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowMultipleTimeReceiptPrint}
                  onToggle={(checked) => handleToggleChange(checked, "AllowMultipleTimeReceiptPrint")}
                  label="Allow Multiple Time Receipt Print"
                  name="AllowMultipleTimeReceiptPrint"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.ShowPrintButtons}
                  onToggle={(checked) => handleToggleChange(checked, "ShowPrintButtons")}
                  label="Show Print Buttons"
                  name="ShowPrintButtons"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Till Discount Options Card */}
        <div className="col-12">
          <div
            className="p-4"
            style={{
              backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
              border: isDarkMode ? "1px solid #404040" : "1px solid #dee2e6",
              borderRadius: "12px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
            }}
          >
            <h6
              style={{
                color: isDarkMode ? "#ffffff" : "#495057",
                fontSize: "1.1rem",
                fontWeight: "600",
                marginBottom: "1.5rem",
                paddingBottom: "0.5rem",
                borderBottom: `2px solid ${themeColor}`,
              }}
            >
              <i className="fa fa-bar-chart me-2" style={{ color: themeColor }}></i>
              EPOS Report Permissions
            </h6>
            <div className="row g-3">
              <div className="col-md-6 col-sm-12 col-12">
                <ToggleSwitch
                  isChecked={formData.isAllowedSaleReport}
                  onToggle={(checked) => handleToggleChange(checked, "isAllowedSaleReport")}
                  label="Allowed Sale Report (EPOS)"
                  name="isAllowedSaleReport"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-md-6 col-sm-12 col-12">
                <ToggleSwitch
                  isChecked={formData.isAllowedGeneralReport}
                  onToggle={(checked) => handleToggleChange(checked, "isAllowedGeneralReport")}
                  label="Allowed General Report (EPOS)"
                  name="isAllowedGeneralReport"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Till Discount Options Card */}
        <div className="col-12">
          <div
            className="p-4"
            style={{
              backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
              border: isDarkMode ? "1px solid #404040" : "1px solid #dee2e6",
              borderRadius: "12px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
            }}
          >

            <div className="row g-3 align-items-center">
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowBasketDiscounts}
                  onToggle={(checked) => handleToggleChange(checked, "AllowBasketDiscounts")}
                  label="Apply Order Discounts"
                  name="AllowBasketDiscounts"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              {formData.AllowBasketDiscounts && (
                <>
                  <div className="col-md-4 col-sm-6 col-12">
                    <FormInput
                      label="Order Discount Limit %"
                      placeHolder="Enter Discount Percentage"
                      type="number"
                      value={formData.BasketDiscountLimitPercentage || ""}
                      onchange={handleInputChange}
                      name="BasketDiscountLimitPercentage"
                      disabled={isReadOnly}
                    />
                  </div>
                  <div className="col-md-4 col-sm-6 col-12">
                    <FormInput
                      label="Maximum discount value"
                      placeHolder="Enter Maximum discount value"
                      type="number"
                      value={formData.BasketDiscountLimit || ""}
                      onchange={handleInputChange}
                      name="BasketDiscountLimit"
                      disabled={isReadOnly}
                    />
                  </div>
                </>
              )}
              <div className="col-md-4 col-sm-6 col-12">
                <ToggleSwitch
                  isChecked={formData.AllowRefunds}
                  onToggle={(checked) => handleToggleChange(checked, "AllowRefunds")}
                  label="Process Customer Refunds"
                  name="AllowRefunds"
                  themeColor={themeColor}
                  disabled={isReadOnly}
                />
              </div>
              {formData.AllowRefunds && (
                <div className="col-md-4 col-sm-6 col-12">
                  <FormInput
                    label="Refund Limit"
                    placeHolder="Enter Refund Limit"
                    type="number"
                    value={formData.RefundLimit || ""}
                    onchange={handleInputChange}
                    name="RefundLimit"
                    disabled={isReadOnly}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateRole;